export default __webpack_public_path__ + "static/media/ic-truck-free-delivery.c33a09f6.svg";